import { render, staticRenderFns } from "./DashboardPantalla.vue?vue&type=template&id=204e70f4&"
import script from "./DashboardPantalla.vue?vue&type=script&lang=ts&"
export * from "./DashboardPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('204e70f4', component.options)
    } else {
      api.reload('204e70f4', component.options)
    }
    module.hot.accept("./DashboardPantalla.vue?vue&type=template&id=204e70f4&", function () {
      api.rerender('204e70f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dashboard/DashboardPantalla.vue"
export default component.exports